var exports = {
  "k": "xfd349460--899482--container",
};

module.exports = exports;
